import { render, staticRenderFns } from "./BatchUpdateModal.vue?vue&type=template&id=4eb6d1e4"
import script from "./BatchUpdateModal.vue?vue&type=script&lang=ts"
export * from "./BatchUpdateModal.vue?vue&type=script&lang=ts"
import style0 from "./BatchUpdateModal.vue?vue&type=style&index=0&id=4eb6d1e4&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports